import React from 'react';
import { Row } from 'antd';
import { _getagreementdetail } from '../../utils/api';
import './index.scss'

class Agreementdetail extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            content: ''
        };
    };

    componentDidMount = () => {
        this.init();
    };

    /** 页面初始化 */
    init = () => {
        let id = this.getParam('id');
        _getagreementdetail({id: id}).then(res => {
            if (res.code === 200) {
                this.setState({ content: res.data[0].content })
            }
        })
    };

    /** 获取页面参数 */
    getParam=(key)=> {
        let param = [];
        let url =this.props.location.search;
        url = url.slice(1).split("&");
        for (let i of url) {
            let newItem = i.split("=");
            param[newItem[0]] = newItem.length === 1 ? "" : decodeURIComponent(newItem[1]);
        }
        return param[key];
    };

    render() {
        const { content } = this.state;
        return (
            <Row className="agreement-detail">
                <div dangerouslySetInnerHTML={{__html: content}}></div>
            </Row>
        )
    }

}

export default Agreementdetail;